import React, { useEffect, useState } from 'react'
import {
  SignupForm,
  signupFormConstraints,
  SignUpPageProps
} from './SignUpPage.types'
import { GENERAL_STORE, USER_STORE } from 'store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { withAlert } from 'react-alert'
import { SignUpPage as SignUpPageUI } from '@touche-lts/panel-ui/dist/components/pages/sign-up-page'
import validate from 'validate.js'

const SignUpPageComponent = (props: SignUpPageProps) => {
  const {
    className,
    style,
    match: {
      params: { code }
    },
    [GENERAL_STORE]: { alert },
    [USER_STORE]: { signUp },
    alert: reactAlert
  } = props

  const [formState, setFormState] = useState<SignupForm>({
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: ''
  })

  useEffect(() => {
    if (alert.counter > 0) {
      reactAlert[alert.type](alert.message)
    }
    // eslint-disable-next-line
  }, [alert.counter])

  const onSignUpClick = () => {
    signUp({
      code,
      firstName: formState.firstName,
      lastName: formState.lastName,
      password: formState.password
    })
  }

  return (
    <SignUpPageUI
      className={className}
      style={style as any}
      firstNameValue={formState.firstName}
      onFirstNameChange={firstName => setFormState(s => ({ ...s, firstName }))}
      lastNameValue={formState.lastName}
      onLastNameChange={lastName => setFormState(s => ({ ...s, lastName }))}
      passwordValue={formState.password}
      onPasswordChange={password => setFormState(s => ({ ...s, password }))}
      confirmPasswordValue={formState.confirmPassword}
      onConfirmPasswordChange={confirmPassword =>
        setFormState(s => ({ ...s, confirmPassword }))
      }
      submitButtonProps={{
        children: 'Sign up',
        onClick: onSignUpClick,
        disabled: validate(formState, signupFormConstraints)
      }}
    />
  )
}

const SignUpPage = withAlert()(
  inject(GENERAL_STORE, USER_STORE)(observer(SignUpPageComponent))
)
export { SignUpPage }
